export enum ApiRequestStatus {
  Idle = 'idle',
  Loading = 'loading',
  Reloading = 'reloading',
  Success = 'success',
  Error = 'error',
  Unavailable = 'unavailable',
}
